import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { generatePageSchema, injectSchema } from '../utils/schemaGenerator';
import { reviewsData } from '../data/reviewsData';
import { tutorialsData } from '../data/tutorialsData';
import { mockPosts } from '../data/blogData';

const SchemaMarkup = () => {
  const location = useLocation();

  useEffect(() => {
    const updateSchema = () => {
      let pageType = 'home';
      let data = {};

      const path = location.pathname + location.hash;

      if (path.includes('#/reviews/')) {
        pageType = 'review';
        const slug = path.split('#/reviews/')[1];
        const review = reviewsData.find(r => r.slug === slug);
        if (review) {
          data = { review };
          document.title = `${review.title} - AI Software Review`;
          const metaDescription = document.querySelector('meta[name="description"]');
          if (metaDescription) {
            metaDescription.setAttribute('content', `Read our in-depth review of ${review.title}. Discover if this AI software is the right digital tool for your business.`);
          }
        }
      } else if (path.includes('#/reviews')) {
        pageType = 'reviews';
        data = { reviews: reviewsData };
        document.title = 'AI Software Reviews & Comparisons - Extraterrestrial Tools';
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
          metaDescription.setAttribute('content', 'Honest reviews and comparisons of the latest AI software and productivity tools. Real testing by entrepreneurs for creators.');
        }
      } else if (path.includes('#/tutorials/')) {
        pageType = 'tutorial';
        const slug = path.split('#/tutorials/')[1];
        const tutorial = tutorialsData.find(t => t.slug === slug);
        if (tutorial) {
          data = { tutorial };
          document.title = `${tutorial.title} - AI Tool Tutorial`;
          const metaDescription = document.querySelector('meta[name="description"]');
          if (metaDescription) {
            metaDescription.setAttribute('content', `Learn how to master ${tutorial.tool} with our step-by-step AI software tutorial.`);
          }
        }
      } else if (path.includes('#/tutorials')) {
        pageType = 'tutorials';
        data = { tutorials: tutorialsData };
        document.title = 'AI Software Tutorials & How-To Guides';
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
          metaDescription.setAttribute('content', 'Expert tutorials for mastering AI software, productivity tools, and digital automation strategies.');
        }
      } else {
        pageType = 'home';
        document.title = 'Extraterrestrial Tools - Best AI Software & Lifetime Deals';
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
          metaDescription.setAttribute('content', 'Discover the best AI software, productivity tools, and exclusive lifetime deals. In-depth reviews and tutorials for creators and entrepreneurs.');
        }
      }

      const schema = generatePageSchema(pageType, data);
      injectSchema(schema);
    };

    updateSchema();
  }, [location]);

  return null;
};

export default SchemaMarkup;